import React from "react";
import lildicks from "../lil_dicks.jpeg";

export default function LandingView() {
  return (
    <div style={styles.container}>
      <h1 style={{ marginBottom: 24, marginTop: 12, textAlign: "center" }}>
        Welcome to Little Richard's!!
      </h1>
      <p style={styles.paragraph}>
        Are you upset about the eggplant life dealt you, and you desperately
        want to cover it up??
      </p>
      <p style={styles.paragraph}>
        Well, then you belong with us, Lil' Richards'. We can help with all of
        your compensatory needs.
      </p>
      <img src={lildicks} alt="lil_dsicks.jpeg" style={{ margin: 20 }} />
      <p style={styles.paragraph}>
        We take our craft and our fonts very seriously.
      </p>
      <p style={styles.paragraph}>
        From loud bikes to big villas to leopard-print onesies, we have it all.
      </p>
      <p style={styles.paragraph}>
        Check out our world-famous Compensatorium today to start feeling like
        the man you never will be!
      </p>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f5f5f5",
    overflow: "scroll",
  },
  paragraph: {
    marginBottom: 12,
    textAlign: "center",
  },
};
